<template>
  <div
    class="px-3 py-3 z-50 text-sm text-gray-50 transition-all duration-300 transform bg-gray-900 bg-opacity-75 border border-gray-300 rounded shadow-md w-96 font-small"
    :class="(show ? 'opacity-100 translate-y-0 ' : 'opacity-0 translate-y-10 ') + elementPosition"
  >
    <div class="flex items-center justify-between">
      <p class="w-5/6">
        <slot />
      </p>

      <div class="flex flex-row">
        <button
          class="focus:outline-none"
          @click="close()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExternalSnackbar',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      elementPosition: 'fixed bottom-5 left-5',
      time: 5000 // 5s
    }
  },

  watch: {
    show: function (val) {
      if (!val) return

      setTimeout(() => {
        this.close()
      }, this.time)
    }
  },

  methods: {
    close () {
      this.$emit('closed', true)
    }
  }
}
</script>
